import { apiService } from "./index";

const resourceListService = {
  getAll() {
    return apiService.get("/resource_lists");
  },

  get(hashid) {
    return apiService.get(`/resource_lists/${hashid}`);
  },

  create(name) {
    return apiService.post("/resource_lists", { name });
  },

  update(hashid, data) {
    return apiService.put(`/resource_lists/${hashid}`, data);
  },

  destroy(hashid) {
    return apiService.delete(`/resource_lists/${hashid}`);
  },

  addItem(hashid, programSiteIds) {
    const ids = Array.isArray(programSiteIds) ? programSiteIds : [programSiteIds];
    return apiService.post(`/resource_lists/${hashid}/resource_list_items`, {
      program_site_ids: ids,
    });
  },

  removeItem(hashid, itemId) {
    return apiService.delete(
      `/resource_lists/${hashid}/resource_list_items/${itemId}`
    );
  },

  share(listInfo) {
    return apiService.post("/share/resource_list", listInfo);
  },
};

export { resourceListService };
